import React from 'react'
import moment from 'moment'
import classnames from 'classnames'

export const ConversationList = ({ conversations, onSetCurrentConversation, currentConversation }) => (
  <>
    {
      !!conversations && conversations.map((conversation=>(
        <Conversation
          key={conversation.id}
          currentConversation={currentConversation}
          onSetCurrentConversation={onSetCurrentConversation}
          conversation={conversation}/>
      )))
    }
  </>
)

const Conversation = ({ conversation, onSetCurrentConversation, currentConversation }) => (
  <div 
    onClick={()=>onSetCurrentConversation(conversation)}
    className={classnames("pt-4 pr-4 pb-4 d-flex align-items-center border-bottom clickable hoverable cursor-default unselectable", { "bg-primary": currentConversation.id == conversation.id })}>
    <div className="pl-2 pr-3">
      <div style={{width: '10px', height: '10px', borderRadius: '50%' }} className={classnames({"bg-primary": conversation.unread_count > 0})}/>
    </div>
    <div className="w-100 pr-4">
      <div className="text-truncate"><b>{ conversation.group_id ? conversation.subject : conversation.title }</b></div>
      <div className="text-truncate pt-2 pb-2">{ conversation.last_message.text }</div>
      <div className="text-secondary">{ moment(conversation.last_message.created_at).format("MM/DD/YYYY hh:mma") }</div>
    </div>
  </div>
)